// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "babel-polyfill";

import axios from "axios";
Vue.prototype.$http = axios;

import "iview/dist/styles/iview.css";
import iview from "./iview";
Vue.use(iview);

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)

//引入过滤器文件
import filters from "./filters";
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

//Vue.prototype.$http.defaults.baseURL = 'https://apitest.znzw.net:6888';
axios.defaults.timeout = 15000;
// 接口重试次数
axios.defaults.retry = 3;
axios.defaults.retryDelay = 600;

console.log("####当前环境为：" + process.env.NODE_ENV);

if (process.env.NODE_ENV === "production") {
  // 生产环境
  Vue.prototype.$BaseHref = "https://base.znzw.net";
  Vue.prototype.$http.defaults.baseURL = "https://api.znzw.net:6888";
  Vue.prototype.$WebSockHref = "wss://iotwss.znzw.net:9288";
} else if (process.env.NODE_ENV === "testing") {
  // 测试环境
  Vue.prototype.$BaseHref = "https://lqbase.znzw.net";
  Vue.prototype.$http.defaults.baseURL = "https://lqapi.znzw.net:6888";
  Vue.prototype.$WebSockHref = "wss://lqiotwss.znzw.net:9288";
} else if(process.env.NODE_ENV === "development") {
  // 开发环境
  Vue.prototype.$BaseHref = "http://localhost:8080";
  Vue.prototype.$http.defaults.baseURL = "http://localhost:7101";
  Vue.prototype.$WebSockHref = "wss://lqiotwss.znzw.net:9288";
}

Vue.config.productionTip = false;

require("../static/css/common.css");

//全局配置信息通知位置及延迟关闭时间
Vue.prototype.$Notice.config({
  top: 150,
  duration: 3
});

Vue.prototype.$Message.config({
  duration: 5
});

//路由守卫，判断是否登录有token
router.beforeEach((to, from, next) => {
  Vue.prototype.$Loading.start();

  if (to.path == "/") {
    if (localStorage.getItem("userInfo")) {
      next({ name: "Home" });
    } else {
      next();
    }
  } else if (to.meta.requiresAuth) {
    if (!localStorage.getItem("userInfo")) {
      next({ path: "/" });
    } else {
      // next();
      // 权限判断
      let userInfo =
        localStorage.getItem("userInfo") == null
          ? ""
          : JSON.parse(localStorage.getItem("userInfo"));
      let perstr = userInfo.perms;
      let perarr = perstr.split(",");
      if (userInfo.admin == 1) {
        next();
      } else {
        if (perarr.includes(to.meta.requiresAuth)) {
          next();
        } else if (userInfo.companyCategory != 60) {
          if (to.path === "/SceneMonit/SiteParti/Circuit") {
            //这就是跳出循环的关键

            next();
          } else {
            next("/SceneMonit/SiteParti/Circuit");
          }
        } else {
          // next({path:'/Home/NoPermission'});
          if (to.path === "/Home/NoPermission") {
            //这就是跳出循环的关键

            next();
          } else {
            next("/Home/NoPermission");
          }
        }
      }
    }
  } else {
    next();
  }
});

router.afterEach(route => {
  Vue.prototype.$Loading.finish();
});

//添加axios请求拦截器    在请求的时候添加token
Vue.prototype.$http.interceptors.request.use(
  function(config) {
    if (
      localStorage.getItem("userInfo") != null &&
      config.url != "/ucms/user/login"
    ) {
      config.headers.Authorization = JSON.parse(
        localStorage.getItem("userInfo")
      ).token;
    }
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    console.log(error);
    return Promise.reject(error);
  }
);

//axios响应拦截器
Vue.prototype.$http.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误 21005 token过期
    if (response.status === 200) {
      if (
        response.data.errcode === 21006 ||
        response.data.errcode === 21004 ||
        response.data.errcode === 21005
      ) {
        sessionStorage.clear();
        localStorage.removeItem("userInfo");
        Vue.prototype.$Message.destroy();
        Vue.prototype.$Message.info("请重新登录！");
        router.replace({
          path: "/"
        });
      }

      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    const errorStr = error.toString();
    if (errorStr.includes("timeout")) {
      Vue.prototype.$Message.error("网络超时，请稍后重试!");
      return Promise.reject(error.response);
    }
    if (error && error.response) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          router.replace({
            path: "/"
          });
          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          //                  Toast({
          //                      message: '登录过期，请重新登录',
          //                      duration: 1000,
          //                      forbidClick: true
          //                  });
          //                  Vue.prototype.$Message
          // 清除token

          localStorage.removeItem("token");
          store.commit("loginSuccess", null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/",
              query: {
                redirect: router.currentRoute.fullPath
              }
            });
          }, 1000);
          break;

        // 404请求不存在
        case 404:
          break;
        // 其他错误，直接抛出错误提示
        default:
        //                  Toast({
        //                      message: error.response.data.message,
        //                      duration: 1500,
        //                      forbidClick: true
        //                  });
      }
      return Promise.reject(error.response);
    }
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});
